var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode)?_c(_vm.mode.component,_vm._b({key:_vm.mode.key,tag:"component"},'component',_vm.mode.props,false),[(_vm.homeMode !== 'mission' && _vm.homeMenu.name !== 'buttons')?_c('HomeMenu',{attrs:{"absolute":""}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }